import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-325c2b40"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex m-auto w-100 align-center justify-content-center" }
const _hoisted_2 = { class: "d-flex align-center" }
const _hoisted_3 = { clas: "user-name" }
const _hoisted_4 = { class: "user-type" }

import { withDefaults, computed, ref } from 'vue';
import { AtomSubTitle, AtomTitle, Filter2Icon, NotificationIcon, AtomCheckBox } from '../atoms';
import { Authentication } from '@/store';
import { onMounted } from 'vue';
import Sidebar from '@/store/modules/sideBar';

interface IProps {
  title?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'OrganismsBar',
  props: {
    title: null
  },
  setup(__props: any) {

const props = __props as { title?: string };

const { showNavigation } = Sidebar();



const filtersOptions = ref<any>([]);

function getFunction() {
  return Authentication.getters.getUser.value?.roles?.map((f) => f.data.role).join(', ') ?? '';
}

const tradutorRole = computed(() => {
  return Authentication.getters.isAdmin.value
    ? 'ADMIN'
    : Authentication.getters.isCollaborator.value
    ? 'COLABORADOR'
    : Authentication.getters.isManager.value
    ? 'GESTOR'
    : Authentication.getters.isMaster.value
    ? 'MASTER'
    : '';
});

return (_ctx: any,_cache: any) => {
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!

  return (_openBlock(), _createBlock(_component_v_app_bar, {
    prominent: "",
    color: "white",
    style: {"padding":"3px 42px"},
    class: "m-auto"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_unref(AtomTitle), {
            noMargin: "",
            title: props.title ?? ''
          }, null, 8, ["title"])
        ]),
        _createVNode(_component_v_spacer),
        _createVNode(_component_router_link, {
          to: "/profile",
          style: {"text-decoration":"none"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_avatar, {
              size: "40",
              rounded: "full",
              class: "me-5",
              style: {"background-color":"#CFCFCF"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_img, {
                  cover: "",
                  src: _unref(Authentication).getters.getUser.value?.image || _unref(Authentication).getters.getUser.value?.name
                }, null, 8, ["src"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createElementVNode("div", null, [
          _createVNode(_component_router_link, {
            to: "/profile",
            style: {"text-decoration":"none"}
          }, {
            default: _withCtx(() => [
              _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(Authentication).getters.getUser.value?.name), 1),
              _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(tradutorRole)), 1)
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }))
}
}

})